<template>
    <div>
        <div v-if="!chattingAvailable" class="form-guide-box is-center mt-0">
            <p class="form-guide">
                <i class="icon icon-info-circle-line"></i>
                {{ $t('paragraphs.chatting_service_not_available')}}
            </p>
        </div>
<!--        채팅 서비스와 전용 플레이어 사용 연관성을 제거함.-->
<!--        <div v-else-if="isExclusivePlayer" class="form-guide-box is-center mt-0">-->
<!--            <p class="form-guide">-->
<!--                <i class="icon icon-info-circle-line"></i>-->
<!--                {{ $t('paragraphs.chatting_exclusive_player_disable_desc1')}}-->
<!--                {{ $t('paragraphs.chatting_exclusive_player_disable_desc2')}}-->
<!--            </p>-->
<!--        </div>-->
        <div v-else>
            <div v-if="haveSubmitRight" class="text-right mb-3">
                <button class="btn btn-primary" @click="onUpdateChattingInfo">{{ $t('words.save') }}</button>
            </div>
            <div class="form-group row">
                <label class="col-md-3">{{ $t('words.chatting_use_yes_no') }}</label>
                <div class="col-md-9">
                    <p class="text-guide">
                        {{ $t('paragraphs.chatting_use_yes_no_tip') }}
                    </p>
                    <div class="form-radio">
                        <input type="radio" :value="true" name="use_chatting_service" id="use_chatting_service_yes" :disabled="!haveSubmitRight" v-model="use_chatting_service" @change="onChangeUseChattingService">
                        <label for="use_chatting_service_yes">{{ $t('words.use_yes') }}</label>
                    </div>
                    <div class="form-radio">
                        <input type="radio" :value="false" name="use_chatting_service" id="use_chatting_service_no" :disabled="!haveSubmitRight" v-model="use_chatting_service" @change="onChangeUseChattingService">
                        <label for="use_chatting_service_no">{{ $t('words.use_no') }}</label>
                    </div>
                    <span class="invalid-feedback" v-if="meta.errors.use_chatting_service" v-for="error in meta.errors.use_chatting_service" :key="error">{{ error }}</span>

                    <!-- 채팅 위치 -->
                    <div class="form__box mt-sp" v-if="chattingType === 'chatroll'">
                        <label class="form__subtitle">{{ $t('words.chatting_position') }}</label>
                        <!--<div class="form-radio">-->
                        <!--<input type="radio" value="top" name="chatting_top" id="chatting_top" :disabled="!haveSubmitRight||!use_chatting_service" v-model="chatting_position">-->
                        <!--<label for="chatting_top">{{ $t('words.top') }}</label>-->
                        <!--</div>-->
                        <div class="form-radio">
                            <input type="radio" value="bottom" name="chatting_bottom" id="chatting_bottom" :disabled="!haveSubmitRight||!use_chatting_service" v-model="chatting_position">
                            <label for="chatting_bottom">{{ $t('words.bottom') }}</label>
                        </div>
                        <div class="form-radio">
                            <input type="radio" value="left" name="chatting_left" id="chatting_left" :disabled="!haveSubmitRight||!use_chatting_service" v-model="chatting_position">
                            <label for="chatting_left">{{ $t('words.left') }}</label>
                        </div>
                        <div class="form-radio">
                            <input type="radio" value="right" name="chatting_right" id="chatting_right" :disabled="!haveSubmitRight||!use_chatting_service" v-model="chatting_position">
                            <label for="chatting_right">{{ $t('words.right') }}</label>
                        </div>
                        <span class="invalid-feedback" v-if="meta.errors.chatting_position" v-for="error in meta.errors.chatting_position" :key="error">{{ error }}</span>
                    </div>
                    <!-- 채팅 종류 -->
                    <div class="form__box mt-sp" v-if="chattingType==='chatroll'">
<!--                        <label class="form__subtitle">{{ $t('words.chatting_type') }}</label>-->
                        <p class="text-guide">
                            {{ $t('paragraphs.chatting_type_tip') }}
                        </p>
                        <div class="form-radio">
                            <input type="radio" :value="true" name="chatting_service_embed" :checked=true :disabled="!haveSubmitRight||!use_chatting_service">
                            <label>{{ $t('words.chatting_type_embed') }}<small style="margin-left: 4px">{{ $t('paragraphs.chatting_type_embed_tip') }}<a href="https://chatroll.com/" target='_blank' class="btn-link ml-2">{{ $t('words.catting_go_chatroll_config') }}</a></small></label>
                            <div class="form__description">
                                <input type="text" id="chatting_embed_code" name="chatting_embed_code" ref="chatting_embed_code" :disabled="!haveSubmitRight||!use_chatting_service" :class="{'form-control':true, 'is-invalid':meta.errors.chatting_embed_code}" :placeholder="$t('paragraphs.placeholder_chatting_embed_code')" v-model="chatting_embed_code" />
                                <span class="invalid-feedback" v-if="meta.errors.chatting_embed_code" v-for="error in meta.errors.chatting_embed_code" :key="error">{{ error }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="form__box mt-sp" v-if="chattingType === 'kollus' || chattingType === 'kollus_server_only' || chattingType === 'tencent'">
                        <div class="form-group" v-if="isKollusChatting && isScalableChatting">
                            <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.scalable_chatting')}}</label>
                            <toggle-button v-model="chatting_scalable" :sync="true" :disabled="!haveOwnerRight||!use_chatting_service"></toggle-button>
                            <span class="form__description" style="margin-left:8px;">{{ $t('paragraphs.chatting_scalable_tip') }}</span>
                            <span class="invalid-feedback" v-if="meta.errors.chatting_scalable" v-for="error in meta.errors.chatting_scalable" :key="error">{{ error }}</span>
                        </div>
                        <div class="form-group" v-if="isKollusChatting || isTencentChatting">
                            <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.chatting_limit_count')}}</label>
                            <input type="text" id="chatting_limit_count" name="chatting_limit_count" :disabled="!haveSubmitRight||!use_chatting_service" :class="{'form-control':true, 'is-invalid':meta.errors.chatting_limit_count}" v-model="chatting_limit_count" style="width:96px" />
                            <span class="invalid-feedback" v-if="meta.errors.chatting_limit_count" v-for="error in meta.errors.chatting_limit_count" :key="error">{{ error }}</span>
                        </div>
                        <div class="form-group" v-if="isKollusChatting">
                            <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.concurrently_chatting_limit')}}</label>
                            <input type="text" id="concurrently_chatting_limit" name="concurrently_chatting_limit" :disabled="!haveSubmitRight||!use_chatting_service" :class="{'form-control':true, 'is-invalid':meta.errors.concurrently_chatting_limit}" v-model="concurrently_chatting_limit" style="width:96px" />
                            <span class="invalid-feedback" v-if="meta.errors.concurrently_chatting_limit" v-for="error in meta.errors.concurrently_chatting_limit" :key="error">{{ error }}</span>
                        </div>
                        <div class="form-group">
                            <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.chatting_join_message')}}</label>
                            <input type="text" id="chatting_join_message" name="chatting_join_message" :disabled="!haveSubmitRight||!use_chatting_service" :class="{'form-control':true, 'is-invalid':meta.errors.chatting_join_message}" v-model="chatting_join_message" />
                            <span class="invalid-feedback" v-if="meta.errors.chatting_join_message" v-for="error in meta.errors.chatting_join_message" :key="error">{{ error }}</span>
                        </div>
                        <div class="form-group" v-if="isKollusChatting || isTencentChatting">
                            <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.chatting_admin_id')}}<span class="text-tooltip v-tooltip-open" v-tooltip="{ content: $t('paragraphs.chatting_admin_id_tooltip') }"><i class="icon icon-info-circle-line"></i></span></label>
                            <textarea id="catting_admin_ids" name="catting_admin_ids" rows="5" :disabled="!haveSubmitRight||!use_chatting_service" :class="{'form-control':true, 'is-invalid':meta.errors.chatting_admin_ids}" v-model="chatting_admin_ids" />
                            <span class="invalid-feedback" v-if="meta.errors.chatting_admin_ids" v-for="error in meta.errors.chatting_admin_ids" :key="error">{{ error }}</span>
                        </div>
                        <div class="form-group" v-if="isKollusChatting">
                            <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.chatting_block_dup_nickname')}}</label>
                            <toggle-button v-model="chatting_block_dup_nickname" :sync="true" :disabled="!haveOwnerRight||!use_chatting_service"></toggle-button>
                            <span class="invalid-feedback" v-if="meta.errors.chatting_block_dup_nickname" v-for="error in meta.errors.chatting_block_dup_nickname" :key="error">{{ error }}</span>
                        </div>

                        <div class="form-group" v-if="isKollusChatting || isTencentChatting">
                            <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.chatting_anonymous_chat')}}</label>
                            <toggle-button v-model="chatting_anonymous_chat" :sync="true" :disabled="!haveOwnerRight||!use_chatting_service"></toggle-button>
                            <span class="invalid-feedback" v-if="meta.errors.chatting_anonymous_chat" v-for="error in meta.errors.chatting_anonymous_chat" :key="error">{{ error }}</span>
                        </div>
                        <div class="form-group" v-if="isKollusChatting || isTencentChatting">
                            <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.chatting_enable_block')}}</label>
                            <toggle-button v-model="chatting_enable_block" :sync="true" :disabled="!haveOwnerRight||!use_chatting_service"></toggle-button>
                            <span class="invalid-feedback" v-if="meta.errors.chatting_enable_block" v-for="error in meta.errors.chatting_enable_block" :key="error">{{ error }}</span>
                        </div>
                        <div class="form-group" v-if="isKollusChatting || isTencentChatting">
                            <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.chatting_profile_photo_display')}}</label>
                            <toggle-button v-model="chatting_display_profile_photo" :sync="true" :disabled="!haveOwnerRight||!use_chatting_service||chatting_anonymous_chat"></toggle-button>
                            <span class="invalid-feedback" v-if="meta.errors.chatting_display_profile_photo" v-for="error in meta.errors.chatting_display_profile_photo" :key="error">{{ error }}</span>

                            <div v-show="haveSubmitRight && chatting_display_profile_photo" style="margin-top:16px;">
                                <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.chatting_profile_default_photo_change')}}</label>
                                <toggle-button v-model="chatting_disable_default_profile_photo" :sync="true" :disabled="!haveOwnerRight||!use_chatting_service"></toggle-button>
                                <span class="invalid-feedback" v-if="meta.errors.chatting_disable_default_profile_photo" v-for="error in meta.errors.chatting_disable_default_profile_photo" :key="error">{{ error }}</span>
                                <div v-show="chatting_disable_default_profile_photo">
                                    <div class="input-group input-group-flat">
                                        <input type="file" ref="profile_photo" accept="image/*" id="upload_profile_photo_file"
                                               :class="{ 'form-control': true, 'is-invalid': chatting_profile_photo.meta.errors.upload_file }"
                                               :readonly="chatting_profile_photo.isUploading"
                                        />
                                        <div class="input-group-append">
                                            <button class="btn" @click="doUploadProfilePhoto()">
                                                <i class="icon icon-upload"></i>{{ $t('words.upload') }}
                                            </button>
                                        </div>

                                        <div class="invalid-feedback" v-for="error in chatting_profile_photo.meta.errors.upload_file" :key="error">{{ error }}</div>
                                    </div>

                                    <div class="progress" style="margin-top: 1em;" v-if="chatting_profile_photo.isUploading">
                                        <div class="progress-bar progress-bar-striped" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                                             :style="{ width: `${chatting_profile_photo.progressValueNow}%` }" :aria-valuenow="chatting_profile_photo.progressValueNow">
                                            {{ chatting_profile_photo.progressValueNow > 0 ? `${chatting_profile_photo.progressValueNow}%` : ''}}
                                        </div>
                                    </div>

                                    <small class="form-text text-muted">
                                        {{ $t('paragraphs.chatting_profile_photo_tip_1') }}
                                    </small>
                                    <small class="form-text text-muted">
                                        {{ $t('paragraphs.chatting_profile_photo_tip_2', { maxWidth: chatting_profile_photo.maxWidth, maxHeight: chatting_profile_photo.maxHeight }) }}
                                    </small>
                                    <div class="thumbnailbox" v-if="chatting_profile_photo_url">
                                        <img :src="chatting_profile_photo_url" class="img-thumbnail" style="max-width:600px;max-height:600px;"/>
                                        <button class="btn btn-outline-danger btn-close" v-if="haveSubmitRight" @click="doRemoveProfilePhoto"><i class="icon icon-close" style="margin: 0;"></i></button>
                                    </div>

                                </div>

                            </div>

                        </div>
                        <div class="form-group" v-if="isKollusChatting || isTencentChatting">
                            <label :class="{'is-disabled': !haveSubmitRight||!use_chatting_service}">{{ $t('words.chatting_send_status')}}</label>
                            <toggle-button v-model="chatting_send_status" :sync="true" :disabled="!haveOwnerRight||!use_chatting_service"></toggle-button><span class="form__description" style="margin-left:8px;">{{ $t('paragraphs.chatting_send_status_tip') }}</span>
                            <span class="invalid-feedback" v-if="meta.errors.chatting_send_status" v-for="error in meta.errors.chatting_send_status" :key="error">{{ error }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        channel: {
            type: [Object],
            require: true,
        },
        modifyMode: {
            type: [Boolean],
            require: true,
        },
        isExclusivePlayer: {
            type: [Boolean],
            require: true,
        },
        currentTab: {
            type: [String],
            require: true,
        },
    },
    data() {
        return {
            tab_name: 'chatting',
            use_chatting_service: false,
            chatting_service_id: -1,
            chatting_service: null,
            // chatting_type: 'kollus',
            chatting_info: null,
            // chatroll
            chatting_embed_code: '',
            // kollus
            chatting_limit_count: 30,
            concurrently_chatting_limit: 300,
            chatting_join_message: '',
            chatting_scalable: false,
            chatting_display_profile_photo: false,
            chatting_disable_default_profile_photo: false,
            chatting_position: 'left',
            chatting_profile_photo: {
                progressValueNow: 0,
                isUploading: false,
                maxWidth: 100,
                maxHeight: 100,
                meta: {
                    errors: {},
                },
            },
            chatting_block_dup_nickname: false,
            chatting_anonymous_chat: false,
            chatting_enable_block: true,
            chatting_send_status: false,
            chatting_profile_photo_url: '',
            chatting_admin_ids: '',
            meta: {
                errors: {},
            },
        };
    },
    methods: {
        initialize() {
            this.use_chatting_service = this.channel.use_chatting_service;
            let channelChattingService;
            let serviceAccountChattingService;
            if (this.channel.chatting_service && 'id' in this.channel.chatting_service) {
                channelChattingService = this.channel.chatting_service;
            }
            if (this.selectedServiceAccount.chatting_service
                && ('id' in this.selectedServiceAccount.chatting_service)) {
                serviceAccountChattingService = this.selectedServiceAccount.chatting_service;
            } else {
                this.use_chatting_service = false;
            }
            // channel, service account가 다른 chatting kind를 가진 경우 service_account의 채팅 속성을 사용한다.
            this.chatting_info = null;
            this.chatting_service_id = serviceAccountChattingService.id;
            if (!_.isEmpty(channelChattingService) && !_.isEmpty(serviceAccountChattingService) &&
                channelChattingService.id === serviceAccountChattingService.id &&
                channelChattingService.kind.type === serviceAccountChattingService.kind.type
            ) {
                // chatting type이 바뀌지 않은 경우에만 가져온다.
                this.getChattingInfo();
            }
            this.chatting_position = this.channel.chatting_position;
            this.chatting_profile_photo_url = this.channel.chatting_profile_photo_url;
            this.concurrently_chatting_limit = this.channel.concurrently_chatting_limit;
            this.chatting_scalable = this.channel.chatting_scalable;

            if (this.chattingType === 'kollus' || this.chattingType === 'tencent') {
                this.initUploadStatus();
            }
        },
        onChangeUseChattingService() {
            if (this.use_chatting_service && this.chattingType === 'chatroll') {
                this.$refs.chatting_embed_code.focus();
            }
        },
        onUpdateChattingInfo() {
            if (!this.haveSubmitRight) {
                this.$toasted.error(this.$t('paragraphs.error.check_login_right'));
                return;
            }

            const confirmMessage = this.$t('paragraphs.chatting_restart_broadcast_to_apply');
            const confirmOptions = {
                action: [
                    {
                        text: this.$t('words.cancel'),
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                    {
                        text: this.$t('words.save'),
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                            this.doUpdateChattingInfo();
                        },
                    },
                ],
                duration: null,
            };
            this.$toasted.info(confirmMessage, confirmOptions);
        },
        doUpdateChattingInfo() {
            this.meta.errors = {};
            axios.patch(`${this.channelApiUri}/${this.channel.id}`, {
                use_chatting_service: this.use_chatting_service,
                chatting_service_id: this.chatting_service_id,
                chatting_type: this.chattingType,
                chatting_position: this.chatting_position,
                chatting_embed_code: this.chatting_embed_code,
                chatting_limit_count: this.chatting_limit_count,
                concurrently_chatting_limit: this.concurrently_chatting_limit,
                chatting_scalable: this.chatting_scalable,
                chatting_join_message: this.chatting_join_message,
                chatting_display_profile_photo: this.chatting_display_profile_photo,
                chatting_disable_default_profile_photo: this.chatting_disable_default_profile_photo,
                chatting_block_dup_nickname: this.chatting_block_dup_nickname,
                chatting_anonymous_chat: this.chatting_anonymous_chat,
                chatting_enable_block: this.chatting_enable_block,
                chatting_admin_ids: this.chatting_admin_ids,
                chatting_send_status: this.chatting_send_status,
            }).then((response) => {
                this.$emit('changedChatting', {
                    use_chatting_service: this.use_chatting_service,
                    chatting_info: response.data.data.chatting_info,
                    chatting_service: this.chatting_service,
                    chatting_position: this.chatting_position,
                    concurrently_chatting_limit: this.concurrently_chatting_limit,
                    chatting_scalable: this.chatting_scalable,
                });
                this.$toasted.success(this.$t('paragraphs.message.success.change'));
            }).catch((error) => {
                this.meta.errors = error.response.data.errors;
                this.$toasted.error(this.$t('paragraphs.message.error.change'));
            });
        },
        /*
        doUpdateChattingInfo() {
            if (!this.haveSubmitRight) {
                this.$toasted.error(this.$t('paragraphs.error.check_login_right'));
                return;
            }

            let confirmMessage;
            if (this.modifyMode) {
                confirmMessage = this.$t('paragraphs.message.confirm.update_item');
            } else {
                confirmMessage = this.$t('paragraphs.message.confirm.create_item');
            }
            if (confirm(confirmMessage)) {
                this.meta.errors = {};
                axios.patch(`${this.channelApiUri}/${this.channel.id}`, {
                    use_chatting_service: this.use_chatting_service,
                    chatting_service_id: this.chatting_service_id,
                    chatting_type: this.chatting_type,
                    chatting_position: this.chatting_position,
                    chatting_embed_code: this.chatting_embed_code,
                    chatting_limit_count: this.chatting_limit_count,
                    concurrently_chatting_limit: this.concurrently_chatting_limit,
                    chatting_scalable: this.chatting_scalable,
                    chatting_join_message: this.chatting_join_message,
                    chatting_display_profile_photo: this.chatting_display_profile_photo,
                    chatting_disable_default_profile_photo: this.chatting_disable_default_profile_photo,
                    chatting_anonymous_chat: this.chatting_anonymous_chat,
                    chatting_enable_block: this.chatting_enable_block,
                    chatting_admin_ids: this.chatting_admin_ids,
                    chatting_send_status: this.chatting_send_status,
                }).then((response) => {
                    this.$emit('changedChatting', {
                        use_chatting_service: this.use_chatting_service,
                        chatting_info: response.data.data.chatting_info,
                        chatting_service: this.chatting_service,
                        chatting_position: this.chatting_position,
                        concurrently_chatting_limit: this.concurrently_chatting_limit,
                        chatting_scalable: this.chatting_scalable,
                    });
                    this.$toasted.success(this.$t('paragraphs.message.success.change'));
                }).catch((error) => {
                    this.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.change'));
                });
            }
        },
        */
        getChattingInfo() {
            const apiUrl = `/console/service-accounts/${this.selectedServiceAccount.key}/channels/${this.channel.key}/chatting-info`;
            axios.get(apiUrl).then((response) => {
                this.chatting_info = response.data.data;
                if (this.chattingType === 'chatroll') {
                    if (this.chatting_info && 'embed_code' in this.chatting_info) {
                        this.chatting_embed_code = this.chatting_info.embed_code;
                    }
                } else if (this.chattingType === 'kollus' || this.chattingType === 'kollus_server_only' || this.chattingType === 'tencent') {
                    if (this.chatting_info && 'join_message' in this.chatting_info) {
                        this.chatting_join_message = this.chatting_info.join_message;
                    }
                    if (this.chattingType === 'kollus' || this.chattingType === 'tencent') {
                        if (this.chatting_info && 'limit_count' in this.chatting_info) {
                            this.chatting_limit_count = this.chatting_info.limit_count;
                        }
                        if (this.chatting_info && 'block_dup_nickname' in this.chatting_info) {
                            this.chatting_block_dup_nickname = this.chatting_info.block_dup_nickname;
                        }
                        if (this.chatting_info && 'anonymous_chat' in this.chatting_info) {
                            this.chatting_anonymous_chat = this.chatting_info.anonymous_chat;
                        }
                        if (this.chatting_info && 'enable_block' in this.chatting_info) {
                            this.chatting_enable_block = this.chatting_info.enable_block;
                        }
                        if (this.chatting_info && 'display_profile_photo' in this.chatting_info) {
                            this.chatting_display_profile_photo = this.chatting_info.display_profile_photo;
                        }
                        if (this.chatting_info && 'disable_default_profile_photo' in this.chatting_info) {
                            this.chatting_disable_default_profile_photo = this.chatting_info.disable_default_profile_photo;
                        }
                        if (this.chatting_info && 'admin_ids' in this.chatting_info) {
                            this.chatting_admin_ids = this.chatting_info.admin_ids;
                        }
                        if (this.chatting_info && 'send_status' in this.chatting_info) {
                            this.chatting_send_status = this.chatting_info.send_status;
                        }
                    }
                }
            });
        },
        initUploadStatus() {
            this.$refs.profile_photo.value = null;
            this.chatting_profile_photo.meta.errors = {};
            this.chatting_profile_photo.isUploading = false;
            this.chatting_profile_photo.progressValueNow = 0;
        },
        /**
         * doUploadPoster
         *
         * @return void
         */
        doUploadProfilePhoto() {
            if (!this.haveSubmitRight) {
                return;
            }
            const formData = new FormData();
            const file = this.$refs.profile_photo.files[0];

            if (typeof file === 'undefined') {
                this.$toasted.error(this.$t('paragraphs.please_select_file'));
                return;
            }

            this.chatting_profile_photo.meta.errors = {};
            this.chatting_profile_photo.isUploading = true;
            formData.append('upload_file', file);

            axios.post(`${this.channelApiUri}/${this.channel.id}/chatting-profile-photo`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: (event) => {
                    const totalLength = event.lengthComputable
                        ? event.total
                        : event.target.getResponseHeader('content-length')
                        || event.target.getResponseHeader('x-decompressed-content-length');
                    if (totalLength != null) {
                        this.chatting_profile_photo.progressValueNow = _.round((event.loaded * 100) / event.total);
                    }
                },
            }).then((response) => {
                this.chatting_profile_photo_url = response.data.chatting_profile_photo_url;
                this.$toasted.success(this.$t('paragraphs.message.success.upload'));
                setTimeout(() => {
                    this.initUploadStatus();
                }, 2000);
            }).catch((error) => {
                this.$toasted.error(this.$t('paragraphs.message.error.upload'));
                this.chatting_profile_photo.meta.errors = error.response.data.errors;
                setTimeout(() => {
                    this.chatting_profile_photo.isUploading = false;
                }, 2000);
            });
        },
        doRemoveProfilePhoto() {
            if (!this.haveSubmitRight) {
                return;
            }

            if (confirm(this.$t('paragraphs.message.confirm.remove_item'))) {
                axios.delete(`${this.channelApiUri}/${this.channel.id}/chatting-profile-photo`).then((response) => {
                    // this.changeChannel(response.data.data);
                    // TODO : change channel data
                    this.chatting_profile_photo_url = '';
                    this.$toasted.success(this.$t('paragraphs.message.success.remove'));
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.remove_file'));
                });
            }
        },
    },
    computed: {
        channelApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/channels`;
        },
        haveSubmitRight() {
            return (!this.modifyMode && this.haveOwnerRight) || (this.modifyMode && this.haveManagerRight);
        },
        isScalableChatting() {
            return this.chattingAvailable && this.selectedServiceAccount.chatting_service.use_scalable;
        },
        isKollusChatting() {
            return (this.chattingType === 'kollus');
        },
        isKollusServerOnlyChatting() {
            return (this.chattingType === 'kollus_server_only');
        },
        isTencentChatting() {
            return (this.chattingType === 'tencent');
        },
        loadedChannel() {
            return this.loadedServiceAccount && ('id' in this.channel) && (this.channel.id !== '');
        },
        selectedTab() {
            return this.loadedChannel && this.currentTab === this.tab_name;
        },
    },
    watch: {
        selectedTab(newValue) {
            if (newValue) {
                this.initialize();
            }
        },
        chatting_display_profile_photo(newValue) {
            if (!newValue) {
                this.chatting_disable_default_profile_photo = false;
            }
        },
        chatting_anonymous_chat(newValue) {
            if (newValue) {
                this.chatting_display_profile_photo = false;
                this.chatting_disable_default_profile_photo = false;
            }
        },
    },
};

</script>
